<div class="fc-detail-form">
  <div class="fc-detail-form-header">
    <span class="material-icons fc-detail-form-icon">person</span>
    <h3 class="fc-detail-form-title">{{ userForm.controls.id.value ? 'Edit User' : 'Add User' }}</h3>
  </div>

  <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="fc-form-grid">
    <input formControlName="id" type="hidden" />

    <mat-form-field appearance="outline">
      <mat-label>Username</mat-label>
      <input matInput formControlName="username" required minlength="8" />
      <mat-error *ngIf="userForm.controls.username.hasError('minlength')">Minimum 8 characters</mat-error>
      <mat-error *ngIf="userForm.controls.username.hasError('required')">Required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Customer</mat-label>
      <mat-select formControlName="customerId" required>
        <mat-option *ngFor="let customer of customers" [value]="customer.id">{{ customer.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" required email />
      <mat-error *ngIf="userForm.controls.email.hasError('email')">Invalid email address</mat-error>
      <mat-error *ngIf="userForm.controls.email.hasError('required')">Required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select formControlName="enabled" required>
        <mat-option [value]="true">Enabled</mat-option>
        <mat-option [value]="false">Disabled</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Role</mat-label>
      <mat-select multiple formControlName="roles" required>
        <mat-option *ngFor="let role of roles" [value]="role">{{ role }}</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="fc-form-actions">
      <button type="reset" class="fc-btn fc-btn--ghost" (click)="clear()">Clear</button>
      <button type="submit" class="fc-btn fc-btn--primary" [disabled]="!userForm.valid">Save</button>
    </div>

    <p class="fc-form-error" *ngIf="userForm.errors?.usernameTaken">This username is already taken.</p>
  </form>
</div>
